import { render, staticRenderFns } from "./ReCardTicketFaqNest.vue?vue&type=template&id=6584739a&scoped=true"
import script from "./ReCardTicketFaqNest.vue?vue&type=script&lang=js"
export * from "./ReCardTicketFaqNest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6584739a",
  null
  
)

export default component.exports